// extracted by mini-css-extract-plugin
export default {"btn_wrapper":"Button_btn_wrapper__b1fNI"};